export const SELECT_DOCUMENT = '@@IMPROVE/SelectDocument';
export const RESET_SELECT_DOCUMENT = '@@IMPROVE/ResetSelectedDocument';
